import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import useShopHeaderImage from '@hooks/images/useShopHeaderImage';
import { COLOR, SIZE } from '@components/SimpleButton';
import DeliveryPartnerInfo from '@shopDetails/components/DeliveryPartnerInfo';
import Tag from '@components/Tag';
import { isClosed, willOpenLater } from '@utils/shop';
import MenuSections from '../../MenuSections';
import {
  BackgroundImage,
  Closed,
  Container,
  ContainerRelative,
  DeliveryInfo,
  HeaderContainer,
  NotificationsContainer,
  OpenIn,
  Rating,
  ReviewsContainer,
  SimpleButton,
  SubHeaderContainer,
  TagContainer,
  Title,
  Wrapper,
} from './components';
import connect from './connect';

const HEIGHT_BACKGROUND = '48px';

function MainHeaderRestaurant({
  shop,
  reviewsRoute,
  show,
  subHeader,
  children,
  onFocusSearch,
  onSelectTab,
  onClickMenu,
  showShimmer,
  weeklyDiscount,
}) {
  const showReviews = useMemo(
    () => shop?.acceptsReviews && shop?.validReviewCount > 0,
    [shop],
  );
  const backgroundImage = useShopHeaderImage(shop);
  const isClosedShop = useMemo(() => isClosed(shop), [shop]);

  return (
    <Container show={show}>
      {showShimmer ? null : (
        <>
          <BackgroundImage
            src={backgroundImage}
            isClosed={isClosedShop}
            height={HEIGHT_BACKGROUND}
          />
          <ContainerRelative>
            <HeaderContainer>
              {isClosedShop && <Closed />}
              {willOpenLater(shop) && <OpenIn nextHour={shop.nextHour} />}
              <Wrapper>
                {Boolean(shop?.name) && <Title>{shop.name}</Title>}
                <DeliveryInfo />
                {Boolean(showReviews) && (
                  <ReviewsContainer>
                    <Rating score={shop.generalScore} />
                    <Link to={reviewsRoute}>
                      <SimpleButton
                        label={`${shop?.validReviewCount} opiniones`}
                        color={COLOR.TERTIARY}
                        size={SIZE.SMALL}
                        isAction
                      />
                    </Link>
                  </ReviewsContainer>
                )}
                <NotificationsContainer>
                  {Boolean(weeklyDiscount?.amount) && (
                    <TagContainer>
                      <Tag
                        type="deals"
                        rounded
                        text={`${weeklyDiscount?.amount} % OFF`}
                      />
                    </TagContainer>
                  )}
                  <DeliveryPartnerInfo />
                </NotificationsContainer>
              </Wrapper>
            </HeaderContainer>
            <MenuSections
              onFocusSearch={onFocusSearch}
              onSelectTab={onSelectTab}
              onClickMenu={onClickMenu}
            />
            {subHeader && <SubHeaderContainer>{subHeader}</SubHeaderContainer>}
            {children}
          </ContainerRelative>
        </>
      )}
    </Container>
  );
}

MainHeaderRestaurant.propTypes = {
  show: PropTypes.bool,
  shop: PropTypes.object.isRequired,
  reviewsRoute: PropTypes.string.isRequired,
  subHeader: PropTypes.node,
  children: PropTypes.node,
  onFocusSearch: PropTypes.func.isRequired,
  onSelectTab: PropTypes.func.isRequired,
  onClickMenu: PropTypes.func,
  showShimmer: PropTypes.bool,
  weeklyDiscount: PropTypes.shape,
};

MainHeaderRestaurant.defaultProps = {
  show: true,
  showShimmer: false,
};

export default connect(MainHeaderRestaurant);
